import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import FigCaptionTagEditing from './figcaptionediting';

export default class FigCaptionTag extends Plugin {
  static get requires() {
    return [ FigCaptionTagEditing ];
  }

  static get pluginName() {
    return 'FigCaptionTag';
  }
}
